import * as React from 'react';
import { SubTitle, Text } from '../../../lib/teacup';

import StripeCheckout, { IToken } from 'react-stripe-checkout';
import { default as billingState } from '../../stores/billing';

import * as userActions from '../../stores/user/actions';
 
import { Box, Button, CircularProgress, LinearProgress, List, ListItem, Stack, TextField, Typography } from '@mui/material';
import { NavigateFunction } from 'react-router-dom';
import { withRouter } from '../hoc/WithRouter';

interface State {
    hasRequestedLicense: boolean;
    showThankYou: boolean;
    allowPurchase: boolean;
    currentProduct: BillingAPI.Product;
    stateCustomer: BillingAPI.CustomerResponse;
}

interface Props {
    user: User;
    team: TeamState;
    org: OrgState;
    appState: AppState;
    licenseData : object;
    setBase:any;
    navigate?: NavigateFunction
}

const subTitleProps = {
    fontSize: "23px"
};

const CHARGE_TABLE_HEADER_STYLE = {
    width: '100%',
    paddingRight: '10px'
}

const CHARGE_TABLE_STYLE = {
    margin: 'auto',
    textAlign: 'right',
    fontSize: '0.9em',
    borderBottom: '1px solid rgba(0,0,0,0.2)',
    width: '400px'
}

interface Refs {
    email?: Input;
    phone?: Input;
}


const CenteredContainer: React.FC = ({ children }) => {
    return (
        <Box
            sx={{
                height: '100vh',     
                width: '100vw',       
                display: 'flex',       
                justifyContent: 'center', 
                alignItems: 'center',   
                textAlign: 'center',    
            }}
        >
            <div>
              {children}
            </div>
        </Box>
    );
};

// Untill the day that we move billingState out of a mobX store
// we need our container to be an observer ot detect payment
// method changes

class NeedLicenseClass extends React.Component<Props, State> {
    ref: Refs = {};

    state: State = {
        hasRequestedLicense: false,
        showThankYou: false,
        allowPurchase: false,
        currentProduct: undefined,
        stateCustomer: undefined
    }

    listenToStores = ['org',  'user', 'team', 'appState','licenseData'];

    componentDidMount() {
        // Load basic customer data, this includes payment methods
        this.handleLoadCustomer();

        this.handleLoadingProductData();

        this.setState({
            allowPurchase: true
        });
    }

    handleLoadCustomer = async() => {
        const { user } = this.props;

        billingState.customer.load(user?.accessToken,(stateError: any, stateResponse: any) => {
            try {
                const stateBody = JSON.parse(stateResponse?.text);
                this.setState({
                    stateCustomer: stateBody
                });

                if (stateError) {
                    console.error(stateError);
                }
            }
            catch(e) {
                this.setState({
                    stateCustomer: {
                        paymentMethod: undefined,
                        last4Digits: undefined
                    }
                });
            }
        });
    }

    componentDidUpdate(prevProps: Props, prevState: State) {
        // Forward the user away from this page if they recieve a valid license
        if (this.props?.licenseData?.valid) {
            this.handleGoHome();
        }

        if (prevProps && prevProps?.org && prevProps?.org?.userRequiredProduct === undefined) {
            if (this.props?.org?.userRequiredProduct) {
                this.handleLoadingProductData();
            }
        }
    }

    getIsLoading = () => {
        return this.state.stateCustomer === undefined;
    }

    handleLoadingProductData = () => {
        const {
            org,
            team,
            user
        } = this.props;

        // Load product details for the current organizations required product
        if (team && org) {
            billingState?.loadProductDetailsV2(user?.accessToken, org?.id, org?.defaultProduct, team?.id, (product) => {
                this.setState({
                    currentProduct: product
                });
            });
        }
    }

    handlePurchaseLicense =async () => {
        const {
            allowPurchase,
            currentProduct
        } = this.state;

        const {
            org,
            user
        } = this.props;

        // If they aren't allowed to purchase a license at this time reject
        // there request
        if (!allowPurchase) return;

        // Otherwise set the flag so they can't request another one
        this.setState({
            allowPurchase: false
        });

        // Purchase 1 license for the organizations required product
        // This isn't stateful due to our implementation of the stripe API
        // Our approach sets a customers default payment method in stripe
        // Then simply attempts a purchase with the default payment from Discovery
        billingState?.purchaseLicense(user?.accessToken, org.id, currentProduct.id, '1', currentProduct.name, (error, response) => {
            // Now we should re-check our users license status
            
            //N.B : Check if we click on purchase and if this is done then move to canvas.
        });
        const checkLicense=await userActions.loadLicenseV2(user, org?.id)
        if(checkLicense.valid===true){
            this.handleGoHome()
        }
    }

    handleGoHome = () => {
        // After purchasing a license the user may travel to the canvas
        this.props.navigate('/canvas');
    }

    handlePaymentMethodToken = (token: IToken) => {
        const {user}=this.props;
        // When the user hits OK on the Stripe Payment method modal
        // save our customer data using the token it provides\
        billingState?.customer?.save(user?.accessToken, token?.id, () => {
            this.handleLoadCustomer();
        });
    }

    handleRequestButton = () => {
        // Toggle the request license display
        this.setState({
            hasRequestedLicense: true
        });
    }

    handleRequestSendButton = () => {
        // Make an API call with the current orgID and user
        // to let our event system know the user has requested a new license
        const { org,user } = this.props;

        let email = '';
        let phone = '';

        if (this.refs.email) {
            const inputElement = this.refs.email.querySelector('input');
            email = inputElement ? inputElement.value : null;
        }

        if (this.refs.phone) {
            const inputElement = this.refs.phone.querySelector('input');
            phone = inputElement ? inputElement.value : null;
        }

        billingState?.requestLicense(user?.accessToken,org?.id, email, phone);

        this.setState({
            showThankYou: true
        });
    }

    // Show this once a valid license has been detected
    renderThankYouPage() {
        const thankYouTitle = <Typography variant="h4" gutterBottom>Thank you for your purchase!</Typography>;

        const thankYouHomeButton = <Button sx={{background:'#e8eaf6',fontSize:'20px',padding:'3px 8px'}} onClick={this.handleGoHome}>Ok</Button>;

        return <CenteredContainer>
            {thankYouTitle}
            <SubTitle {...subTitleProps}>
                {thankYouHomeButton}
            </SubTitle>
        </CenteredContainer>;
    }

    renderContactPage() {
        const {
            hasRequestedLicense,
            showThankYou
        } = this.state;

        const {
            user
        } = this.props;

        // Check up top for a thank you return
        if (showThankYou) {
            const contactPageTitle = <Typography variant="h4" gutterBottom>Thank You</Typography>;

            let contactPageDetails = <p style={{fontSize:'20px'}}>We will be contacting you shortly.</p>

            return <CenteredContainer>
                {contactPageTitle}
                {contactPageDetails}
            </CenteredContainer>;
        }

        const contactPageTitle = <Typography variant="h4" gutterBottom>Your license for this organization has expired. </Typography>
        let contactPageDetails = <p ><Button sx={{background:'#e8eaf6',fontSize:'20px',padding:'3px 8px'}} onClick={this.handleRequestButton}>Please contact your administrator for details.</Button></p>

        const labelWidth = 240;

        if (hasRequestedLicense) {
            // Instead make the contact page details a basic form
            contactPageDetails = <p style={{
                width: "500px",
                margin: "auto"
            }}>
                <List size="auto" style={{padding: '16px 0'}}>
                    <ListItem>
                        <TextField
                            value={user?.email} 
                            style={{width: '100%'}}
                            label="Email:"
                            variant="outlined"
                            ref='email' />
                    </ListItem>
                    <ListItem>
                        <TextField
                            value={user?.phone} 
                            label="Phone:"
                            variant="outlined"
                            style={{width: '100%'}}
                            ref='phone' />
                    </ListItem>
                </List>
                <Button sx={{background:'#e8eaf6',fontSize:'16px',padding:'3px 8px'}} onClick={this.handleRequestSendButton}>Contact me to renew my license</Button>
            </p>
        }

        return <CenteredContainer>
            {contactPageTitle} 
            {contactPageDetails}
        </CenteredContainer>;
    }

    // Correctly render a currency in USD
    renderCurrencyAsSpan(currency) {
        // TODO: Move this to a util/global location for other currency displays
        const formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2
        });

        return <span>
            {formatter.format(currency)}
        </span>
    }

    renderChargeTable(price, fee, total) {
        return <table style={CHARGE_TABLE_STYLE}>
            <tr>
                <td style={CHARGE_TABLE_HEADER_STYLE}>Price:</td>
                <td>{this.renderCurrencyAsSpan(price)}</td>
            </tr>
            <tr style={{fontSize: '0.8em'}}>
                <td style={CHARGE_TABLE_HEADER_STYLE}>Processing Fee:</td>
                <td>{this.renderCurrencyAsSpan(fee)}</td>
            </tr>
            <tr>
                <td style={CHARGE_TABLE_HEADER_STYLE}><b>Total:</b></td>
                <td>{this.renderCurrencyAsSpan(total)}</td>
            </tr>
        </table>
    }

    // Show this when we lack a valid license and the user needs to purchase one
    renderPurchasePage() {
        const {
            currentProduct
        } = this.state;

        // Untill we've loaded our product details show a loading screen
        if (currentProduct === undefined) {
            return <CenteredContainer>
                <Box sx={{marginTop: '15px', display: 'block', width: '100%'}}>
                    <LinearProgress />
                </Box>
            </CenteredContainer>
        }

        // Grab some information about the product attached to this org
        // and return a page to purchase 1 unit of that product
        let currentPrice = parseInt(currentProduct?.price);
        let currentFee = currentPrice * 0.03;
        let currentTotal = currentPrice + currentFee;
        let productName = currentProduct?.name;

        const purchaseTitle = <Typography variant="h4" gutterBottom>You don't have an active license to access this organization!</Typography>;

        const purchaseSubTitle = <p style={{fontSize:"18px"}}>
                                    <p>Please purchase your <strong>{productName}</strong> license to gain access to the platform.</p>
                                    <br></br>
                                    {this.renderChargeTable(currentPrice, currentFee, currentTotal)}
                                    <br></br>
                                    {this.renderPaymentMethods()}
                                    {this.renderPaymentActions()}
                                </p>;

        return <CenteredContainer>
            {purchaseTitle}
            {purchaseSubTitle}
        </CenteredContainer>
    }

    renderPaymentActions() {
        const {
            allowPurchase
        } = this.state;

        const customer = this.state.stateCustomer;

        let isPaymentDisabled = false;

        if (customer.paymentMethod === "") {
            isPaymentDisabled = true;
        }

        if (!allowPurchase) {
            isPaymentDisabled = true;
        }

        return [
            <Button sx={{margin:'0px 5px'}} disabled={isPaymentDisabled} onClick={this.handlePurchaseLicense}>
                Purchase
            </Button>
        ];
    }

    renderPaymentMethods() {
        // Render a component to allow the user to select a payment method 
        // with the StripeCheckout module
        const { user } = this.props;
        const customer = this.state.stateCustomer;
        const stripeKey  = process.env.NEXT_PUBLIC_STRIPE_KEY || "pk_test_1OkQuyfLn8XBGnjI9fek8Fuo";

        const paymentMethodLabelProps = {
            color: "blue",
            lightSwatch: "400"
        }

        // Make sure the payment method exists before rendering
        const currentPaymentMethod = 
            customer.paymentMethod ?
            <Box>
                <Stack direction="row" alignItems="center" spacing={2}> 
                    <Typography sx={{padding:'3px 8px',background:'#2196f3',color:'white'}} >{customer?.paymentMethod.toUpperCase() || 'VISA'}</Typography>
                    <Text > 
                        XXXX-XXXX-XXXX-{customer.last4Digits || 'XXXX'}
                    </Text>
                </Stack> <Text inline {...paymentMethodLabelProps}>
                    CHANGE
                </Text>
            </Box> : 
            <span>
                <span> 
                    <Text inline> 
                        
                    </Text>
                </span> <Text inline {...paymentMethodLabelProps}>
                    Add A Payment Method
                </Text>
            </span>;

        if (customer && user){
            return <StripeCheckout
                    name="Innovation Within"
                    label="Add Payment Method"
                    panelLabel="Authorize"
                    token={this.handlePaymentMethodToken}
                    allowRememberMe={false}
                    email={user?.email}
                    stripeKey={stripeKey}>
                            <Button  sx={{background:'#eeeeee', padding:'40px 30px'}}>{currentPaymentMethod}</Button>
                </StripeCheckout>
        }
    }

    renderLoadingPage = () => {
        return <CenteredContainer>
                <CircularProgress />
        </CenteredContainer>;
    }

    render() {
        if (this.getIsLoading()) {
            return this.renderLoadingPage();
        }

        const { appState, org, licenseData } = this.props;
        ////First make it workable
        // Check if this org permits the user to purchase
        // there own license
        if (org.canUserPurchaseLicense === 0){
            return this.renderContactPage();
        }
        else{
            // If we still have an invalid license then present the user with a page to purhcase a valid one
            if (licenseData.valid === false){
                return this.renderPurchasePage();
            }
            else{
                return this.renderThankYouPage();
            }
        }
    }
}
const NeedLicense = withRouter(NeedLicenseClass)
export { NeedLicense };
